import React, { createContext, useContext, useState, useEffect } from "react";

// Create the Sidebar context
const SidebarContext = createContext();

// Sidebar Provider component to wrap around the application
export const SidebarProvider = ({ children }) => {
  const [isCollapsed, setIsCollapsed] = useState(false); // Manage collapsed state
  const [windowWidth, setWindowWidth] = useState(window.innerWidth); // Manage window width

  // Handle window resize event
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Toggle sidebar collapse state
  const toggleCollapse = () => setIsCollapsed((prevState) => !prevState);

  return (
    <SidebarContext.Provider
      value={{ isCollapsed, toggleCollapse, windowWidth }}
    >
      {children}
    </SidebarContext.Provider>
  );
};

// Custom hook to use the Sidebar context
export const useSidebar = () => useContext(SidebarContext);
